import React from "react";
import TextField from "@mui/material/TextField";

interface FeedNameInputProps {
    value: string;
    onChange: (value: string) => void;
}

const FeedNameInput: React.FC<FeedNameInputProps> = ({ value, onChange }) => {
    return (
        <div>
            <label htmlFor="feed-name" className="tw-block tw-mb-1 tw-text-[14px] tw-text-[#555E67]">
                Name Your Feed
            </label>
            <TextField
                id="feed-name"
                variant="outlined"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                fullWidth
                InputProps={{ sx: { borderRadius: 2 } }}
                size="small"
            />
        </div>
    );
};

export default FeedNameInput;
